export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9921.5cb79196.jpg";